angular.module('resyApp')
  .constant('Widget', false);

export default () => {};
